export const DollHouseSkeleton = () => (
  <div className="w-full h-[370px] bg-gray-100 rounded-lg flex items-center justify-center animate-pulse">
    <div className="text-center">
      <div className="w-12 h-12 mx-auto mb-4 bg-gray-300 rounded-full animate-spin border-4 border-gray-300 border-t-blue-500"></div>
      <p className="text-gray-600">Loading 3D View...</p>
    </div>
  </div>
);
